import type { TFunction } from 'i18next';

import { PostFeedType } from '@/features/posts/types/postFeed';

/**
 * Sender-aware channel label. Same idea as backend-side channel naming, but
 * resolved in the frontend so we don't need a separate `channelName` per
 * sender in the feature config.
 *
 * Today only Gossip is overridden for organization senders — "Tratsch" / "Gossip"
 * does not fit an official org post, so we render "Beitrag" / "Post" instead.
 */
export const resolveChannelLabel = (
  channelType: PostFeedType,
  channelName: string,
  isOrganization: boolean,
  t: TFunction<'post-creation', 'screens.post-editor'>
): string => {
  if (channelType === PostFeedType.GOSSIP && isOrganization) {
    return t('channel.gossip.organization');
  }
  return channelName;
};
